export default __webpack_public_path__ + "static/media/abi-logo.a696b41a.png";